import { render, staticRenderFns } from "./reklama.vue?vue&type=template&id=4bf83ed0&"
import script from "./reklama.vue?vue&type=script&lang=js&"
export * from "./reklama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports